import React from 'react';

import styled from '@emotion/styled';

import { Button, mq } from '@clutter/clean';

import { flushEvents, track } from '@root/initializers/wt';

import heroImg from './images/hero.png';

import {
  HeroContainer,
  HeroContent,
  HeroHeadline,
  HeroImage,
  HeroImageColumn,
  HeroImageWrapper,
  HeroInner,
  HeroTextColumn,
} from './hero_layout';

const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  align-self: stretch;
  ${mq({
    flexDirection: ['column', 'column', 'row'],
    gap: ['16px', '16px', '10px'],
  })}

  button {
    display: flex;
    justify-content: center;
    padding: var(--S, 18px) 43px;
    align-items: center;
    gap: 10px;
    border-radius: var(--L, 36px);
    background: var(--Primary, #097e77);
    color: var(--Typography-Cloud, #fff);
    text-align: center;
    font-feature-settings:
      'liga' off,
      'clig' off;
    font-family: 'Basier Square';
    font-style: normal;
    font-weight: 500;
    line-height: 120%;
    ${mq({
      width: ['100%', 'auto', 'auto'],
      fontSize: ['18px !important', '18px !important', 'inherit'],
    })}
  }
`;

export const LocationsHero: React.FC = () => {
  const handleGetPricingClick = () => {
    track({
      action: 'click',
      label: 'Get pricing',
      container: 'locations_hero',
      objectType: 'button',
      objectName: 'get_pricing',
    });
    flushEvents();
    window.location.href = '/p/smart_storage';
  };

  return (
    <HeroContainer>
      <HeroInner>
        <HeroContent>
          <HeroTextColumn>
            <HeroHeadline as="h2">
              Full-service storage made real easy
            </HeroHeadline>
            <ButtonWrapper>
              <Button
                onClick={handleGetPricingClick}
                size="large"
                kind="primary"
              >
                Get pricing
              </Button>
            </ButtonWrapper>
          </HeroTextColumn>
          <HeroImageColumn>
            <HeroImageWrapper>
              <HeroImage src={heroImg} alt="Storage service illustration" />
            </HeroImageWrapper>
          </HeroImageColumn>
        </HeroContent>
      </HeroInner>
    </HeroContainer>
  );
};
